// src/components/Tickets/OrderTicketButton.js

import React, { useState, useEffect, useMemo } from "react" // 1. Import useMemo
import { collection, query, where, getDocs, doc } from "firebase/firestore"
import { useAuthContext } from "../../hooks/useAuthContext"
import NewTicketDrawer from "./NewTicketDrawer"
import { db } from "../../firebase/config"
import { useCollection } from "../../hooks/useCollection"

const OrderTicketButton = ({ order = {} }) => {
  const [selectableOrders, setSelectableOrders] = useState([])
  const [loading, setLoading] = useState(false)
  const { winder, vivaUser, arsomaUser } = useAuthContext()

  // 3. Get all users so we can find the paper managers
  const { data: usersData } = useCollection("users")

  // This is the data-fetching logic, which is correct and stays
  useEffect(() => {
    let isMounted = true
    const fetchOrders = async () => {
      if (!winder && !vivaUser && !arsomaUser) return
      if (isMounted) setLoading(true)
      try {
        let q
        const ordersRef = collection(db, "orders")
        if (winder) q = query(ordersRef, where("orderStatus", "==", 5))
        else if (vivaUser) q = query(ordersRef, where("orderStatus", "==", 4))
        else if (arsomaUser) q = query(ordersRef, where("orderStatus", "==", 3))

        const snap = await getDocs(q)
        const fetchedOrders = snap.docs.map((d) => ({ id: d.id, ...d.data() }))
        if (isMounted) setSelectableOrders(fetchedOrders)
      } catch (err) {
        console.error("Failed to fetch orders for ticket:", err)
      } finally {
        if (isMounted) setLoading(false)
      }
    }
    fetchOrders()
    return () => {
      isMounted = false
    }
  }, [winder, vivaUser, arsomaUser])

  // 4. Define the special autofill rules for an Order ticket
  const initialFormValues = useMemo(() => {
    // Wait for the necessary data
    if (!order.id || !usersData) return {}

    // If the order has a specific status, find paper managers
    if ([3, 3.5, 4, 5].includes(order.orderStatus)) {
      const paperManagerIds = usersData
        .filter((u) => u.group?.includes("paperManager"))
        .map((u) => u.id)

      return {
        issueType: "Technical",
        assignedTo: paperManagerIds,
      }
    }
    // For all other order statuses, return no special rules
    return {}
  }, [order, usersData])

  // This function is correct and stays
  const handleOrderTicketCreate = (batch, { contextId, assignedToIds }) => {
    if (!contextId) return
    const orderRef = doc(db, "orders", contextId)
    batch.update(orderRef, {
      orderStatus: 998,
      holdOrderAssignedIds: assignedToIds,
    })
  }

  return (
    <NewTicketDrawer
      contextItem={order}
      contextType="Order"
      selectableItems={selectableOrders}
      itemsLoading={loading}
      onTicketCreate={handleOrderTicketCreate}
      initialFormValues={initialFormValues} // 5. Pass the calculated values to the drawer
    />
  )
}

export default OrderTicketButton
